'use memo';

import IconButton from '@/components/Button/IconButton';
import Icon from '@/components/Icon/Icon';
import type { IconName } from '@/components/Icon/iconMap';
import { Text } from '@/components/Typography';
import { defaultNS, useTranslation } from '@/lib/i18n';
type AiChatContextPillProps = {
  label: string;
  iconName?: IconName;
  onDismiss: () => void;
};
export function AiChatContextPill({
  label,
  iconName,
  onDismiss
}: AiChatContextPillProps) {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'component.globalAiChat'
  });
  return <div className="flex items-center justify-between rounded-full border border-neutral-muted-border bg-neutral-bottom-fill px-3 py-1">
      <div className="flex min-w-0 items-center gap-2">
        {iconName ? <Icon iconName={iconName} size={14} inheritColor /> : null}
        <Text variant="labelExSmall" className="truncate text-neutral-on-fill">
          {label}
        </Text>
      </div>
      <IconButton icon="XIcon" variant="mutedGhost" size="ExtraSmall" aria-label={t('dismissContextAriaLabel')} onClick={onDismiss} />
    </div>;
}